<template>
  <div class="report-card">
    <Card class="position-relative mb-5 transition-all duration-300 ease-in-out position-relative shadow min-h-375px">
      <div v-if="projectData.is_oldest" class="position-absolute top-0 end-0 translate-middle z-index-3 fs-2x w-25px h-25px" :class="projectData.alertCount ? 'me-10' : 'me-0'">
        😴
      </div>
      <div v-if="projectData.alertCount" class="alert-badge w-25px h-25px p-2 d-flex align-items-center justify-content-center">
        {{ projectData.alertCount }}
      </div>
      <a class="d-block position-relative w-full h-7px " :style="{'border-top-left-radius': '8px', 'border-top-right-radius': '8px', 'background-color':projectData.category?.color}"></a>

      <div class="card-xl-stretch cursor-pointer">
        <div class="d-flex flex-column align-self-stretch px-5 pt-5">
          <div @click.prevent="handleClick" class="fs-2 text-dark fw-bolder text-hover-primary text-dark lh-base d-flex w-100 mb-5">
            <SubTextField :txt="projectData.title" :size="30" />
          </div>

          <div class="accordion-item mb-2 border-0">
            <div @click.prevent="toggleContactAccordion" class="d-flex justify-content-between ">
              <div class="fs-4">{{$t('projects.label.customer') }}</div>
              <div class="d-flex justify-content-end flex-wrap">
                <div v-for="(contact, idx) in projectData.contacts" :key="contact?.id"  v-show="idx < 2" class="text-primary fw-bold bg-light-primary px-2 py-1 rounded mx-1 mb-1">
                  {{contact.contact_name}} <span class="badge badge-primary">{{contact.status_name}}</span>
                </div>
                <div v-if="(projectData.contacts && projectData.contacts.length > 2)" class="text-muted px-2 py-1 mx-1 mb-1">
                  <span v-if="!showAccordion"> +{{ projectData.contacts.length - 2 }} <i class="fa fa-angle-down"></i></span>
                  <span v-else> -{{ projectData.contacts.length - 2 }} <i class="fa fa-angle-up"></i></span>
                </div>
              </div>
            </div>

            <div v-show="projectData.contacts.length > 2" :id="'contact_accordion_body'+projectData.id" class="accordion-collapse collapse" :class="{ 'show border-bottom': showAccordion }">
              <div class="accordion-body d-flex justify-content-end flex-wrap m-0 p-0">
                <div v-for="(contact, idx) in projectData.contacts" :key="contact?.id" v-show="idx >= 2"class="text-primary fw-bold bg-light-primary px-2 py-1 rounded mx-1 mb-1">
                  {{contact.contact_name}} <span class="badge badge-primary">{{contact.status_name}}</span>
                </div>
              </div>
            </div>
          </div>
          <div @click.prevent="handleClick" class="d-flex justify-content-between mb-2">
            <div class="fs-4">{{$t('projects.label.num') }}</div>
            <div class=" fw-bold fs-4" >
              <SubTextField :txt="projectData?.reference" :size="30" />
            </div>
          </div>
          <div @click.prevent="handleClick" class="d-flex justify-content-between mb-2">
            <div class="fs-4">{{$t('projects.label.cat') }}</div>
            <div class="text-dark fw-bold fs-4">
              <SubTextField :txt="projectData.category?.name" :size="30" />
            </div>
          </div>
          <div @click.prevent="handleClick" class="d-flex justify-content-between mb-2">
            <span class="fs-4">{{$t('projects.label.startDate') }} </span>
            <span class="fw-bold fs-4">{{$dateFormatter(projectData.start_date, locale)}}</span>
          </div>
          <div @click.prevent="handleClick" v-if="projectData.end_date" class="d-flex justify-content-between mb-2">
            <span class="fs-4">{{$t('projects.label.endDate') }} </span>
            <span class="fw-bold fs-4">{{$dateFormatter(projectData.end_date, locale)}}</span>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <div class="fs-4">{{$t('projects.label.keywords') }}</div>
            <div class="fw-bold fs-4 text-capitalize">
              {{ projectData?.key_word?.length > 0 ? projectData?.key_word[0] : '' }}
            </div>
          </div>
          <div v-if="projectData.latest_comment" @click="onCommentClick($event, projectData.latest_comment?.comment)" class="d-flex justify-content-between">
            <span class="fs-4">{{$t('projects.label.last_comment') }} </span>
            <span class="fw-bold fs-4 text-truncate col-5 text-end" v-html="extractFirstElement(projectData.latest_comment.comment)"></span>
          </div>
          <div  v-if="projectData.managers?.length > 0" class="d-flex justify-content-between align-items-center mt-2">
            <span class="fs-4">{{$t('projects.manage_project')}}</span>
            <div class="symbol-group symbol-hover">
              <div v-for="manager in projectData?.managers" :key="manager?.id" class="symbol symbol-35px symbol-circle"  :title="manager?.lastname +' '+manager?.firstname" >
                <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{manager?.initials}}</span>
              </div>
            </div>
          </div>
          <div v-if="projectData.users?.length > 0" class="d-flex justify-content-between align-items-center mt-2">
            <span class="fs-4">{{$t('projects.assigned')}}</span>
            <div  class="symbol-group symbol-hover">
              <div v-for="manager in projectData?.users" :key="manager?.id" class="symbol symbol-35px symbol-circle"  :title="manager?.lastname +' '+manager?.firstname" >
                <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{manager?.initials}}</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center my-2">
            <div class="d-flex justify-content-center align-items-center">
              <span :class=" 'me-3 fs-4 text-' + projectData?.status_formatted?.color">{{ projectData?.status_formatted?.[locale] }}</span>
              <div class="circle-progress-wrapper">
                <circle-progress
                    :size="40"
                    empty-color="#E7E6E6"
                    :border-width="5"
                    :border-bg-width="5"
                    :show-percent="false"
                    :percent="projectData?.progress"
                    :fill-color="$getColor(projectData?.status_formatted?.color)"
                />
                <span class="progress-unit">{{ projectData?.progress }}%</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center me-5" v-if="projectData?.total_task_remaining_review">
                <span class="me-2" style="color: #5e6278;">{{ (projectData?.total_task_remaining_review || 0) + '/' + (projectData?.total_task_need_review || 0) }}</span>
                <img src="/assets/media/tasks/review.png" style="height: 20px;" :title="$t('projects.label.total_task_remaining_review')"/>
              </div>
              <div class="d-flex align-items-center" v-if="projectData?.total_task_reviewed">
                <span class="me-2 text-success">{{ (projectData?.total_task_reviewed || 0) + '/' + (projectData?.total_task_need_review || 0) }}</span>
                <img src="/assets/media/tasks/validate.png" style="height: 20px;" :title="$t('projects.label.total_task_reviewed')" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer p-5 mt-auto" v-if="projectData?.history">
        <LastUpdate :id="'card'+projectData.id" :history="projectData?.history"/>
      </div>
      <div class="d-flex gap-2 position-absolute bottom-0 translate-middle-y mb-n18 ">
        <template v-if="Object.keys(projectReactsGrouped).length">
          <FolderCardReactResume
              v-for="(reacts, emoji) in projectReactsGrouped"
              :key="emoji"
              :folder-id="projectData.id"
              :emoji="emoji"
              :reacts="reacts"
              :total="reacts.length"
              @callback="$emit('reloadData')"
          />
        </template>
        <FolderCardQuickComment
            v-if="projectComments.length"
            with-total
            :addComment="toggleQuickCommentModal"
            :total="projectComments.length"
            :classes="'text-primary'"
        />
        <div class="d-flex gap-2 report-comment-action">
          <FolderCardQuickReact :folder="projectData" @callback="$emit('reloadData')" />
          <FolderCardQuickComment  v-if="!projectComments.length" :addComment="toggleQuickCommentModal" />
        </div>
      </div>
    </Card>
  </div>
  <LastCommentModal :id="'last_comment_modal_'+projectData.id" :comment="lastComment" />
  <QuickCommentModal
      :id="'quick-folder-comment-modal-'+projectData.id"
      :form="{...quickCommentData, id: projectData.id, oldComments: projectComments}"
      @callback="$emit('reloadData')"/>
</template>

<script setup>
import {computed, ref, defineProps, watch} from "vue";
    import Card from '@/components/Card.vue';
    import SubTextField from "@/components/SubTextField.vue";
    import "vue3-circle-progress/dist/circle-progress.css";
    import CircleProgress from "vue3-circle-progress";
    import { useRoute } from "vue-router";
    import { useLocales } from "@/composables/locales";
    import LastUpdate from "./LastUpdate.vue";
    import {$getColor, $dateFormatter, formatRemainingTime} from "@/mixins/Helpers";
    import LastCommentModal from "../views/Projects/components/modals/LastCommentModal.vue";
    import FolderCardQuickComment from "@/Modules/Projects/views/Reports/components/FolderCardQuickComment.vue";
    import FolderCardReactResume from "@/Modules/Projects/views/Reports/components/FolderCardReactResume.vue";
    import FolderCardQuickReact from "@/Modules/Projects/views/Reports/components/FolderCardQuickReact.vue";
    import QuickCommentModal from "@/Modules/Projects/views/Reports/components/QuickCommentModal.vue";

    defineEmits(['reloadData'])
    const props = defineProps({
        project: {
            type: Object,
            required: true
        },
        handleProjectClick: {
            type: Function,
            default: () => {}
        }
    })

    const {locale} = useLocales()
    const route = useRoute()
    const projectData = ref(props.project)
    const lastComment = ref('')
    const showAccordion = ref(false)
    const quickCommentData = ref({
      id: '',
      comment: '',
    })


    const projectReacts = computed(() => props.project.commentsList?.EMOJI || [])

    const projectReactsGrouped = computed(() => {
      if (projectReacts.value.length) {
        return projectReacts.value.reduce((acc, react) => {
          const key = react.comment
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(react)
          return acc
        }, {})
      }
      return {}
    })

    const projectComments = computed(() => {
      if(props.project && props.project.commentsList) {
        return props.project.commentsList?.TEXT || []
      }
      return []
    })

    watch(() => props.project, (newVal) => {
        projectData.value = newVal
    }, {deep: true})


    const handleClick = () => {
      props.handleProjectClick(props.project?.id)
    }

    function extractFirstElement(html) {
        const div = document.createElement('div');
        div.innerHTML = html;

        const firstChild = div.firstElementChild;
        if (firstChild) {
            return firstChild.textContent.trim();
        }

        return div.textContent.trim();
    }

    function onCommentClick(event, comment) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
        lastComment.value = comment
        $('#last_comment_modal_'+projectData.value?.id).modal('toggle')
    }

    function toggleQuickCommentModal() {
      $('#quick-folder-comment-modal-'+projectData.value.id).modal('toggle')
    }


    function toggleContactAccordion() {
      showAccordion.value = !showAccordion.value;
    }
</script>

<style scoped>
.report-card {
  padding-bottom: 20px;
}

.report-comment-action {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-5px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.report-card:hover .report-comment-action {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.circle-progress-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.progress-unit {
    position: absolute;
    font-size: 10px;
}

@keyframes pulse {
  0% { transform: translate(50%, -50%) scale(1); opacity: 1; }
  50% { transform: translate(50%, -50%) scale(1.4); opacity: 0.6; }
  100% { transform: translate(50%, -50%) scale(1); opacity: 1; }
}


</style>
